import React, { useState, useRef, useEffect } from 'react';

const TypePopover = ({ isOpen, onClose, onSelect, position, selectedType }) => {
  const [hoveredIndex, setHoveredIndex] = useState(-1);
  const popoverRef = useRef(null);

  const types = [
    { id: 'deposit', name: 'Deposit' },
    { id: 'payout', name: 'Payout' },
    { id: 'refund', name: 'Withdrawal' },
  ];

  // Close popover when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handleTypeSelect = (type) => {
    onSelect(type);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      ref={popoverRef}
      className="fixed z-50 bg-white rounded-lg shadow-lg border border-gray-200 py-2 min-w-[200px]"
      style={{
        top: position?.top || 0,
        left: position?.left || 0,
      }}
    >
      {types.map((type, index) => (
        <div
          key={type.id}
          className={`px-4 py-3 cursor-pointer transition-colors ${
            selectedType?.id === type.id
              ? 'bg-gray-100 text-gray-900'
              : hoveredIndex === index
              ? 'bg-gray-50 text-gray-900'
              : 'text-gray-700 hover:bg-gray-50'
          }`}
          style={{ borderRadius: "10px", margin: "4px" }}
          onMouseEnter={() => setHoveredIndex(index)}
          onMouseLeave={() => setHoveredIndex(-1)}
          onClick={() => handleTypeSelect(type)}
        >
          <div className="flex items-center gap-3">
            <span className="text-sm font-medium">{type.name}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TypePopover;